export function addDownloadCacheBuster(downloadUrl, cacheKey) {
  const path = String(downloadUrl || "").trim();
  if (!path) return path;
  const token = String(cacheKey || "").trim();
  if (!token) return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}v=${encodeURIComponent(token)}`;
}
